export const dashboardStyles = {
    container: {
        backgroundColor: '#F8F9FA',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        color: '#111827',
        fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    },
    content: {
        flex: 1,
        padding: '24px 32px',
    },
    filtersRow: {
        display: 'flex',
        gap: '16px',
        alignItems: 'center',
        marginBottom: '24px',
        flexWrap: 'wrap',
        backgroundColor: '#FFFFFF',
        padding: '16px 20px',
        borderRadius: '12px',
        border: '1px solid #E9ECEF',
        boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
    },
    filterGroup: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },
    filterLabel: {
        fontSize: '0.875rem',
        color: '#6B7280',
        fontWeight: 500,
    },
    select: {
        padding: '10px 16px',
        borderRadius: '8px',
        border: '1px solid #D1D5DB',
        backgroundColor: '#FFFFFF',
        color: '#111827',
        fontSize: '0.9rem',
        minWidth: '200px',
        outline: 'none',
        transition: 'border-color 0.2s',
    },
    dateInput: {
        padding: '10px 16px',
        borderRadius: '8px',
        border: '1px solid #D1D5DB',
        backgroundColor: '#FFFFFF',
        color: '#111827',
        fontSize: '0.9rem',
        outline: 'none',
        transition: 'border-color 0.2s',
    },
    filterBtn: {
        padding: '10px 24px',
        backgroundColor: '#3B82F6',
        color: '#FFFFFF',
        border: 'none',
        borderRadius: '8px',
        fontWeight: 600,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        transition: 'background-color 0.2s, transform 0.1s',
    },
    kpiGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: '20px',
        marginBottom: '24px',
    },
    kpiCard: {
        backgroundColor: '#FFFFFF',
        borderRadius: '12px',
        padding: '24px',
        border: '1px solid #E9ECEF',
        display: 'flex',
        alignItems: 'center',
        gap: '20px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
        transition: 'transform 0.2s, boxShadow 0.2s',
    },
    kpiIcon: {
        width: '56px',
        height: '56px',
        borderRadius: '12px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '1.5rem',
        color: '#FFFFFF',
    },
    kpiValue: {
        fontSize: '2rem',
        fontWeight: 700,
        color: '#111827',
        lineHeight: 1,
    },
    kpiLabel: {
        fontSize: '0.9rem',
        color: '#6B7280',
        marginTop: '4px',
        fontWeight: 500,
    },
    kpiMeta: {
        fontSize: '0.8rem',
        color: '#F97316',
        marginTop: '8px',
        fontWeight: 500,
    },
    kpiSubtext: {
        fontSize: '0.75rem',
        color: '#9CA3AF',
        marginTop: '2px',
    },
    chartsRow: {
        display: 'grid',
        gridTemplateColumns: '2fr 1fr',
        gap: '20px',
        marginBottom: '24px',
    },
    chartCard: {
        backgroundColor: '#FFFFFF',
        borderRadius: '12px',
        padding: '24px',
        border: '1px solid #E9ECEF',
        boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
        minWidth: 0,
    },
    chartCardFull: {
        backgroundColor: '#FFFFFF',
        borderRadius: '12px',
        padding: '24px',
        border: '1px solid #E9ECEF',
        boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
        minWidth: 0,
        gridColumn: '1 / -1',
    },
    chartTitle: {
        fontSize: '1.1rem',
        fontWeight: 700,
        color: '#111827',
        marginBottom: '20px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
    },
    detailsRow: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
        gap: '20px',
        marginBottom: '24px',
    },
    sectionTitle: {
        fontSize: '1rem',
        fontWeight: 600,
        color: '#6B7280',
        marginBottom: '16px',
        marginTop: '8px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
    },
    additionalChartsRow: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
        gap: '20px',
        marginBottom: '24px',
    },
    legendItem: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        fontSize: '0.875rem',
        color: '#374151',
        marginTop: '10px',
    },
    legendDot: {
        width: '10px',
        height: '10px',
        borderRadius: '50%',
    },
    legendGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
        gap: '8px',
        marginTop: '16px',
    },
    donutCenter: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        textAlign: 'center',
    },
    viewMore: {
        fontSize: '0.875rem',
        color: '#3B82F6',
        cursor: 'pointer',
        marginTop: '12px',
        fontWeight: 600,
        display: 'inline-block',
        textDecoration: 'none',
    },
    chartInfo: {
        fontSize: '0.8rem',
        color: '#3B82F6',
        marginTop: '12px',
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
    }
};

